import React, { useEffect, useState } from "react";
import styles from "./clearedBalance.module.css";
import Tabs_ from "common/Tabs";
import FormFields from "components/Form";
import DataTable_ from "common/DataTable";
import { getAll } from "utils/queries";

const ClearedBalance = () => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [financeData, setFinanceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [yourEvents, setYourEvents] = useState({
    from: "",
    to: "",
    brand: "All",
  });

  const TabList = [
    { label: "Cleared balance" },
  ];

  const handleChange = (label) => (e) => {
    setYourEvents((prevDetails) => ({
      ...prevDetails,
      [label]: e.target ? e.target.value : e,
    }));
  };

  const formatDateForAPI = (dateString) => {
    if (!dateString) return "";
    
    // Convert input date to ISO format (YYYY-MM-DD)
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  };

  const getAllEventsWithTransfer = async ({
    limit = 10,
    status = "succeeded",
    offset = 0,
    from = "",
    to = "",  
  }) => {
    try {
      // Format dates for API
      const formattedFrom = formatDateForAPI(from);
      const formattedTo = formatDateForAPI(to);

      setLoading(true);
      setError(null);
      const result = await getAll(
        `stripe/finance?limit=${limit}&offset=${offset}&status=${status}&start_date=${formattedFrom}&end_date=${formattedTo}`
      );
      
      
      if (result?.data) {
        const transformedData = result.data.finance.reverse().map((item) => ({
          cleared_date: item.cleared_date || 'N/A',
          type: item.type || 'N/A',
          paid_in: item.paid_in || 0,
          paid_out: item.paid_out || 0,
          balance: item.balance || 0,
          name: item.name || 'N/A',
        }));
        
        setFinanceData(transformedData);
      } else {
        setFinanceData([]);
      }
    } catch (error) {
      console.error(error);
      setError('Failed to fetch finance data');
      setFinanceData([]);
    } finally {
      setLoading(false);
    }
  };

  // Initial load when component mounts
  useEffect(() => {
    if (selectedTabIndex === 0) {
      getAllEventsWithTransfer({ limit: 10, offset: 0, from: "", to: "" });
    }
  }, [selectedTabIndex]);

  // Trigger API call when date filters change
  useEffect(() => {
    getAllEventsWithTransfer({ 
      limit: 10, 
      offset: 0, 
      from: yourEvents.from, 
      to: yourEvents.to 
    });
  }, [yourEvents.from, yourEvents.to]);

  const Fields = [
    {
      label: null,
      style: {
        display: "flex",
        justifyContent: "flex-start",
        width: "50%",
        gap: "10px",
      },
      children: [
        {
          label: "From",
          id: "from",
          placeholder: "1st July, 2024",
          type: "datePicker",
          selected: yourEvents?.from,
          inputStyleOverride: styles.dateStyles,
          required: false,
          onChange: handleChange("from"),
        },
        {
          label: "To",
          id: "to",
          placeholder: "31 July, 2024",
          type: "datePicker",
          selected: yourEvents?.to,
          inputStyleOverride: styles.dateStyles,
          required: false,
          onChange: handleChange("to"),
        },
        // {
        //   label: "Brand",
        //   id: "brand",
        //   placeholder: "£ 0.00",
        //   type: "select",
        //   value: yourEvents?.brand,
        //   required: false,
        //   options: [],
        //   onChange: handleChange("brand"),
        // },
      ],
    },
  ];

  const YourEventsContent = () => {
    const columns = [
      {
        name: "Cleared",
        selector: (row) => {
          const dateToFormat = row.created_at || row.cleared_date || new Date();
          const date = new Date(dateToFormat);

          const formattedDate = date.toLocaleDateString("en-GB", {
            weekday: "short",
            day: "numeric",
            month: "short",
            year: "numeric",
          });

          const formattedTime = date.toLocaleTimeString("en-GB", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });

          return (
            <div>
              {formattedDate} <br /> at {formattedTime}
            </div>
          );
        },
        // width: "fit-content",
      },
      {
        name: "Type",
        // selector: (row) => row.type,
        selector: (row) => {
          // Capitalize the first letter of the type
          const type = row.type || '';
          return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
        }
      },
      {
        name: "Name",
        cell: (row) => row.name || "_",
      },
      {
        name: "Paid In",
        cell: (row) => `£${Math.abs(row.paid_in).toFixed(2)}` || "_",
      },
      {
        name: "Paid Out",
        cell: (row) =>  `£${Math.abs(row.paid_out).toFixed(2)}` || "_",
      },
      {
        name: "Balance",
        cell: (row) => `£${row.balance.toFixed(2)}`,
      },
    ];

    return (
      <>
        {/* {Fields.map((field) => (
          <div key={field.label || "field-group"} style={field.style}>
            {field.parentLabel && (
              <label
                style={{
                  display: "block",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                {field.parentLabel}
              </label>
            )}
            <FormFields Fields={field.children || [field]} />
          </div>
        ))} */}
        {loading ? (
          <div>Loading...</div>
        ) : error ? (
          <div style={{ color: 'red' }}>{error}</div>
        ) : (
          <DataTable_ 
            data={financeData} 
            columns={columns} 
            pagination={true} 
            paginationPerPage={10}
          />
        )}
      </>
    );
  };

  const TabContent = [{ content: <YourEventsContent /> }];
  // TabContent.push({ content: <YourEventsContent /> });
  // TabContent.push({ content: <YourEventsContent /> });
  return (
    <Tabs_
      // TabList_={TabList}
      TabContent_={TabContent}
      TabListStyleOverride={styles.TabListClass}
      selectedIndex={selectedTabIndex}
      setSelectedIndex={(e) => setSelectedTabIndex(e)}
    />
  );
};

export default ClearedBalance;